import Vue from 'vue'

import uiBoxMenu from './src/ui-box-menu.vue';

Vue.component('ui-box-menu', uiBoxMenu);

export default uiBoxMenu;



//////////////////
// WEBPACK FOOTER
// ./~/ui-box-menu/index.js
// module id = 540
// module chunks = 0